import * as React from 'react'
import { ScrollView, Text, View } from 'react-native'
import styled from '@theme/styled-components'

import Picker from '@components/picker/Picker'
import TextInput from '@components/textInput/TextInput'
import Animators from '@components/root/Animators'

import useI18n from '@i18n/useI18n'
import useBreakpoint from '@utils/useBreakpoints'

import { FormikHelpers, useFormik } from 'formik'

interface Values {
  name: string
  typeUtilisateur: TypeUtilisateurRole
}

const TYPES = ['VIPARIS', 'PRESTATAIRE', 'ORGANISATEUR'] as const

const Info = ({ form, onForm }: AdminRoleFormProps) => {
  const init: Values = React.useMemo(
    () => ({ name: form.name, typeUtilisateur: form.typeUtilisateur }),
    [form.name, form.typeUtilisateur]
  )

  const i18n = useI18n()
  const [, bp] = useBreakpoint()

  const onSubmit = (vals: Values, { setSubmitting }: FormikHelpers<Values>) => {
    onForm(vals).finally(() => setSubmitting(false))
  }

  const { values, setFieldValue, handleSubmit, dirty } = useFormik<Values>({
    enableReinitialize: true,
    initialValues: init,
    onSubmit,
  })

  React.useEffect(() => {
    if (dirty) {
      // sumbit on change, with debounce effect
      const debounce = setTimeout(handleSubmit, 200)
      return () => clearTimeout(debounce)
    }
  }, [values])

  const typeOptions = TYPES.map((t) => ({ label: i18n.t(`screens.admin.roles.form.info.types.${t}`), value: t }))

  return (
    <MainContainer contentContainerStyle={{ paddingHorizontal: bp === 'phone' ? 16 : 45, paddingVertical: 16 }}>
      <Animators>
        {/* nom */}
        <Title>{i18n.t('screens.admin.roles.form.info.name')}</Title>
        <TextInput
          value={values.name}
          onChange={(val) => setFieldValue('name', val)}
          placeholder={i18n.t('screens.admin.roles.form.info.name')}
        />

        {/* typeUtilisateur */}
        <Title>{i18n.t('screens.admin.roles.form.info.type')}</Title>
        <ZContainer index={2}>
          <Picker
            options={typeOptions}
            value={typeOptions.find((opt) => opt.value === form.typeUtilisateur)}
            onChange={(next) => setFieldValue('typeUtilisateur', next ? next.value : undefined)}
            placeholder={i18n.t('screens.admin.roles.form.info.type')}
          />
        </ZContainer>
      </Animators>
    </MainContainer>
  )
}

export default Info

const MainContainer = styled(ScrollView)`
  flex: 1;
`

const Title = styled(Text)`
  ${(props) => props.theme.fonts.Headline};
  margin-bottom: 5px;
  margin-top: 15px;
`

const ZContainer = styled(View)<{ index: number }>`
  z-index: ${(props) => props.index};
`
